import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getEnginesRequired = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.enginesRequired;
};
export default getEnginesRequired;
